/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon32Regular = forwardRef('ArrowAUpLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M21.5 5a1 1 0 1 1 0 2h-13c-.028 0-.056 0-.084.002l17.791 17.79a1 1 0 0 1-1.414 1.415L7.003 8.417A1.52 1.52 0 0 0 7 8.5v13a1 1 0 1 1-2 0v-13A3.5 3.5 0 0 1 8.5 5h13Z" })));
});
